import { BasketItemType } from '../../../../types/basket.d';
import * as BasketControl from '../../../../weborder/BasketControl';

const summariseBasketItems = (items): BasketItemType[] => {
  const counts: any = {};

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    const optionList = item.Options.map((o) => o.Name).join(', ');
    const optionTotal = BasketControl.ItemTotal(item);
    const key = `${item.Item.Name}//${optionList}//${optionTotal}`;

    if (counts[key]) {
      counts[key].quantity++;
      counts[key].index = i;
      counts[key].item = item.Item;
      counts[key].options = item.Options;
    } else {
      counts[key] = {
        item: item.Item,
        index: i,
        options: item.Options,
        quantity: 1,
      };
    }
  }

  return counts;
};

export const basketUtils = {
  summariseBasketItems,
};
